export const globalSearchEn: Record<string, string> = {
  'globalSearch.placeholder': 'Search customers, leads, orders, products...',
  'globalSearch.noResults': 'No results found for',
  'globalSearch.hint': 'Start typing to search across all entities...',
  'globalSearch.customers': 'Customers',
  'globalSearch.leads': 'Leads',
  'globalSearch.orders': 'Orders',
  'globalSearch.products': 'Products',
  'globalSearch.appointments': 'Appointments',
  'globalSearch.measurements': 'Measurements',
  'globalSearch.wedding': 'Wedding',
  'globalSearch.stage': 'Stage',
  'globalSearch.source': 'Source',
  'globalSearch.status': 'Status',
  'globalSearch.created': 'Created',
};
